<template>
	<div class="category-form-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-left">
					<div class="back-button" @click="back()">
						<i class="el-icon-arrow-left"></i>
					</div>
					<div class="header-info">
						<h1 class="page-title">
							{{ type === 'info' ? '分类详情' : (id ? '编辑分类' : '新增分类') }}
						</h1>
						<div class="breadcrumb">
							<span class="breadcrumb-item">产品分类管理</span>
							<i class="el-icon-arrow-right"></i>
							<span class="breadcrumb-current">
								{{ type === 'info' ? '查看详情' : (id ? '编辑分类' : '新增分类') }}
							</span>
						</div>
					</div>
				</div>
				<div class="header-actions" v-if="type !== 'info'">
					<el-button @click="back()" class="cancel-btn">
						<i class="el-icon-close"></i>
						取消
					</el-button>
					<el-button type="primary" @click="onSubmit" :loading="submitLoading" class="submit-btn">
						<i class="el-icon-check"></i>
						{{ submitLoading ? '保存中...' : '保存' }}
					</el-button>
				</div>
				<div class="header-actions" v-else>
					<el-button @click="back()" class="back-btn">
						<i class="el-icon-back"></i>
						返回
					</el-button>
				</div>
			</div>
		</div>

		<!-- 表单内容 -->
		<div class="form-content">
			<el-form
				ref="ruleForm"
				:model="ruleForm"
				:rules="rules"
				label-width="120px"
				class="category-form"
			>
				<!-- 基本信息 -->
				<div class="form-section">
					<h3 class="section-title">分类信息</h3>
					
					<!-- 产品分类 -->
					<el-form-item label="产品分类" prop="chanpinfenlei" class="form-item">
						<div class="input-wrapper">
							<div class="input-field" :class="{ 'readonly': type === 'info' || ro.chanpinfenlei }">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.chanpinfenlei" 
									placeholder="请输入产品分类名称" 
									:readonly="type === 'info' || ro.chanpinfenlei"
									clearable
									class="form-input"
								></el-input>
								<div class="readonly-indicator" v-if="type === 'info' || ro.chanpinfenlei">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip" v-if="type !== 'info'">请输入具体的产品分类名称，如"抗生素"、"维生素"等</span>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
	data() {
		let self = this
		var validateIdCard = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!checkIdCard(value)) {
				callback(new Error("请输入正确的身份证号码"));
			} else {
				callback();
			}
		};
		var validateUrl = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isURL(value)) {
				callback(new Error("请输入正确的URL地址"));
			} else {
				callback();
			}
		};
		var validateMobile = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isMobile(value)) {
				callback(new Error("请输入正确的手机号码"));
			} else {
				callback();
			}
		};
		var validatePhone = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isPhone(value)) {
				callback(new Error("请输入正确的电话号码"));
			} else {
				callback();
			}
		};
		var validateEmail = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isEmail(value)) {
				callback(new Error("请输入正确的邮箱地址"));
			} else {
				callback();
			}
		};
		var validateNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isNumber(value)) {
				callback(new Error("请输入数字"));
			} else {
				callback();
			}
		};
		var validateIntNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isIntNumer(value)) {
				callback(new Error("请输入整数"));
			} else {
				callback();
			}
		};
		return {
			id: '',
			type: '',
			submitLoading: false, // 提交加载状态
			
			ro:{
				chanpinfenlei : false,
			},
			
			ruleForm: {
				chanpinfenlei: '',
			},
		
			rules: {
				chanpinfenlei: [
				],
			}
		};
	},
	props: ["parent"],
	computed: {



	},
	created() {
	},
	methods: {
		
		// 下载
		download(file){
			window.open(`${file}`)
		},
		// 初始化
		init(id,type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			if(this.type=='info'||this.type=='else'){
				this.info(id);
			}else if(this.type=='logistics'){
				this.logistics=false;
				this.info(id);
			}else if(this.type=='cross'){
				var obj = this.$storage.getObj('crossObj');
				for (var o in obj){
						if(o=='chanpinfenlei'){
							this.ruleForm.chanpinfenlei = obj[o];
							this.ro.chanpinfenlei = true;
							continue;
						}
				}
				

			}
			
			
			// 获取用户信息
			this.$http({
				url: `${this.$storage.get('sessionTable')}/session`,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					
					var json = data.data;
				} else {
					this.$message.error(data.msg);
				}
			});
			
			
		},
    // 多级联动参数

    info(id) {
      this.$http({
        url: `chanpinfenlei/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
        //解决前台上传图片后台不显示的问题
        let reg=new RegExp('../../../upload','g')//g代表全部
        } else {
          this.$message.error(data.msg);
        }
      });
    },


    // 提交
    onSubmit() {
      var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(statusColumnName && !statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }

        this.submitLoading = true;

       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "chanpinfenlei/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.$message.error(this.$storage.get('tips'));
					     this.submitLoading = false;
					       return false;
				       } else {
					 this.$http({
					   url: `chanpinfenlei/${!this.ruleForm.id ? "save" : "update"}`,
					   method: "post",
					   data: this.ruleForm
					 }).then(({ data }) => {
					   this.submitLoading = false;
					   if (data && data.code === 0) {
					     this.$message({
					       message: "操作成功",
					       type: "success",
					       duration: 1500,
					       onClose: () => {
						 this.parent.showFlag = true;
						 this.parent.addOrUpdateFlag = false;
						 this.parent.chanpinfenleiCrossAddOrUpdateFlag = false;
						 this.parent.search();
						 this.parent.contentStyleChange();
					       }
					     });
					   } else {
					     this.$message.error(data.msg);
					   }
					 });

				       }
				} else { 
				  this.submitLoading = false;
				} 
			});
		 } else {
			 this.$http({
			   url: `chanpinfenlei/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
			   this.submitLoading = false;
			   if (data && data.code === 0) {
			     this.$message({
			       message: "操作成功",
			       type: "success",
			       duration: 1500,
			       onClose: () => {
				 this.parent.showFlag = true;
				 this.parent.addOrUpdateFlag = false;
				 this.parent.chanpinfenleiCrossAddOrUpdateFlag = false;
				 this.parent.search();
				 this.parent.contentStyleChange();
			       }
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			 });
		 }
         } else {
           this.submitLoading = false;
         }
       });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.chanpinfenleiCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
  }
};
</script>
<style lang="scss" scoped>
.category-form-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 20px 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-left {
			display: flex;
			align-items: center;
			gap: 16px;
			flex: 1;

			.back-button {
				width: 40px;
				height: 40px;
				background: #f8fafc;
				border: 1px solid #e2e8f0;
				border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.2s ease;
				color: #64748b;

				&:hover {
					background: #f1f5f9;
					border-color: #cbd5e1;
					color: #475569;
				}

				&:active {
					background: #e2e8f0;
				}

				i {
					font-size: 16px;
				}
			}

			.header-info {
				.page-title {
					font-size: 20px;
					font-weight: 600;
					color: #1e293b;
					margin: 0 0 4px 0;
					line-height: 1.2;
				}

				.breadcrumb {
					display: flex;
					align-items: center;
					gap: 8px;
					font-size: 13px;
					color: #64748b;

					.breadcrumb-item {
						color: #64748b;
					}

					.breadcrumb-current {
						color: #10b981;
						font-weight: 500;
					}

					i {
						font-size: 12px;
						color: #94a3b8;
					}
				}
			}
		}

		.header-actions {
			display: flex;
			gap: 12px;
			align-items: center;

			.el-button {
				padding: 10px 20px;
				font-weight: 500;
				border-radius: 6px;
				font-size: 14px;
				display: flex;
				align-items: center;
				gap: 6px;

				i {
					font-size: 14px;
				}
			}

			.cancel-btn {
				color: #6b7280;
				border-color: #d1d5db;
				background: white;

				&:hover {
					color: #374151;
					border-color: #9ca3af;
					background: #f9fafb;
				}
			}

			.submit-btn {
				background: #10b981;
				border-color: #10b981;
				color: white;

				&:hover {
					background: #059669;
					border-color: #059669;
				}

				&:disabled {
					background: #d1d5db;
					border-color: #d1d5db;
					color: #9ca3af;
				}
			}

			.back-btn {
				background: #6b7280;
				border-color: #6b7280;
				color: white;

				&:hover {
					background: #4b5563;
					border-color: #4b5563;
				}
			}
		}
	}
}

// 表单内容
.form-content {
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	overflow: hidden;

	.category-form {
		padding: 0;

		// 表单区块
		.form-section {
			padding: 24px;
			border-bottom: 1px solid #f1f5f9;

			&:last-child {
				border-bottom: none;
			}

			.section-title {
				font-size: 16px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 20px 0;
				padding-bottom: 12px;
				border-bottom: 2px solid #10b981;
				display: inline-block;
			}
		}

		// 表单项
		.form-item {
			margin-bottom: 24px;

			&:last-child {
				margin-bottom: 0;
			}

			:deep(.el-form-item__label) {
				font-weight: 600;
				color: #374151;
				font-size: 14px;
				line-height: 1.5;
				padding: 0 12px 0 0;
			}

			:deep(.el-form-item__content) {
				line-height: 1.5;
			}

			// 输入框包装器
			.input-wrapper {
				.input-field {
					position: relative;
					display: flex;
					align-items: center;
					background: white;
					border: 1px solid #d1d5db;
					border-radius: 6px;
					transition: all 0.2s ease;

					&:focus-within {
						border-color: #10b981;
						box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
					}

					&.readonly {
						background: #f8fafc;
						border-color: #e2e8f0;
					}

					.field-icon {
						width: 16px;
						height: 16px;
						margin: 0 12px;
						fill: #64748b;
						flex-shrink: 0;
					}

					.form-input {
						flex: 1;

						:deep(.el-input__inner) {
							border: none;
							padding: 12px 0;
							font-size: 14px;
							line-height: 1.5;
							color: #1e293b;
							background: transparent;

							&::placeholder {
								color: #9ca3af;
							}

							&:focus {
								box-shadow: none;
							}

							&[readonly] {
								background: transparent;
								color: #6b7280;
							}
						}
					}

					.readonly-indicator {
						margin-right: 12px;
						display: flex;
						align-items: center;
						
						.lock-icon {
							width: 14px;
							height: 14px;
							fill: #94a3b8;
						}
					}
				}

				.field-tip {
					display: block;
					margin-top: 6px;
					font-size: 12px;
					color: #6b7280;
					line-height: 1.4;
				}

				.error-tip {
					display: block;
					margin-top: 6px;
					font-size: 12px;
					color: #ef4444;
					line-height: 1.4;
				}
			}
		}

		// 错误状态
		:deep(.el-form-item.is-error) {
			.input-field {
				border-color: #ef4444;

				&:focus-within {
					border-color: #ef4444;
					box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
				}
			}
		}

		// 必填标识
		:deep(.el-form-item.is-required) {
			.el-form-item__label::before {
				content: '*';
				color: #ef4444;
				margin-right: 4px;
			}
		}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.category-form-container {
		padding: 20px;
	}

	.form-content {
		.category-form {
			.form-section {
				padding: 20px;
			}
		}
	}
}

@media (max-width: 768px) {
	.category-form-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			align-items: stretch;

			.header-left {
				justify-content: flex-start;
			}

			.header-actions {
				justify-content: center;
				order: -1;

				.el-button {
					flex: 1;
					max-width: 120px;
				}
			}
		}
	}

	.form-content {
		.category-form {
			:deep(.el-form-item__label) {
				text-align: left;
				float: none;
				display: block;
				width: 100% !important;
				margin-bottom: 8px;
				padding: 0;
			}

			:deep(.el-form-item__content) {
				margin-left: 0 !important;
			}

			.form-section {
				padding: 16px;
			}
		}
	}
}

@media (max-width: 480px) {
	.category-form-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-left {
				.back-button {
					width: 36px;
					height: 36px;

					i {
						font-size: 14px;
					}
				}

				.header-info {
					.page-title {
						font-size: 18px;
					}

					.breadcrumb {
						font-size: 12px;
					}
				}
			}

			.header-actions {
				.el-button {
					padding: 8px 16px;
					font-size: 13px;

					i {
						font-size: 13px;
					}
				}
			}
		}
	}

	.form-content {
		.category-form {
			.form-section {
				padding: 12px;

				.section-title {
					font-size: 15px;
					margin-bottom: 16px;
				}
			}

			.form-item {
				margin-bottom: 20px;

				.input-wrapper {
					.input-field {
						.field-icon {
							width: 14px;
							height: 14px;
							margin: 0 10px;
						}

						.form-input {
							:deep(.el-input__inner) {
								padding: 10px 0;
								font-size: 14px;
							}
						}
					}

					.field-tip {
						font-size: 11px;
					}
				}
			}
		}
	}
}
</style>
